const qs = require('qs');

export default {
    data() {
        return {
            exportUrl: ''
        }
    },

    computed: {
        exportParams() {
            let sort = '';
            if (this.httpOptions && this.httpOptions.params && this.httpOptions.params.sort) {
                sort = this.httpOptions.params.sort;
            }
            return Object.assign({ sort }, this.moreParams || {});
        },
    },

    methods: {
        convertExportParams(type) {
            return qs.stringify(Object.assign({ type: type }, this.exportParams), {
                arrayFormat: 'brackets',
                encode: false
            });
        },

        convertParams(params) {
            return qs.stringify(Object.assign({}, params), {
                arrayFormat: 'brackets',
                encode: false
            });
        },

        exportTo(type, id) {
            let params = this.convertExportParams(type);
            window.open(this.exportUrl + (id ? ('/' + id) : '') + '?' + params, '_blank');
        },

        exportExcel() {
            this.exportTo('xlsx');
        },

        exportExcel(id) {
            this.exportTo('xlsx', id);
        },

        exportXLS() {
            this.exportExcel();
        },

        exportXLSX() {
            this.exportExcel();
        },

        exportCSV() {
            this.exportTo('csv');
        },

        exportPDF() {
            this.exportTo('pdf');
        },
    }
}
